export default __webpack_public_path__ + "static/media/caixa-gov.20a82c8a.png";